import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Card } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { ActionButton, DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { _global_buttonStyles, __OBJECT_STRUCTURE_GetList } from '../../../common/ObjectStructures/Trasnversal';
import PropTypes from 'prop-types';
import CLabel from '../../../components/Common/CLabel';
import NoDataLayer from '../../../components/Common/NoDataLayer';
import { base64ToArrayBuffer, convertToLocalClientTimeZone, isNullUndefined, saveByteArray } from '../../../common/Helpers';
import moment from 'moment';
import { Icon, TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import List from '../../../components/Templates/List';
import MessageIconStatus from '../../../components/Products/sBook/MessageIconStatus';
import CTextAreaSimple from '../../../components/Common/CTextAreaSimple';
import QRCode from 'react-qr-code';
import { css } from '@fluentui/react/lib/Utilities';
import ListPagination from '../../../components/Templates/List/ListPagination';
import { useGetDocumentListByMessageFromMessageBox } from '../../../hooks/services/sBook/useOfDocument';
import { useGetMessageById } from '../../../hooks/services/sBook/useOfMessage';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { downloadDocumentsByIds } from '../../../services/sBook/document.service';
import SidePanelEdit from '../../../components/Products/sBook/V3/MessageBox/SidePanelEdit';
import { __OBJECT_STRUCTURE_GetUserProps } from '../../../common/ObjectStructures/sBook';
import { useGetMessageBookMemberRelationshipProps } from '../../../hooks/services/sBook/useOfUser';
import { useGetBookById } from '../../../hooks/services/sBook/useOfBook';
import { useSelector } from 'react-redux';

const SidePanelViewBookTask = (props) => {
    const { t } = useTranslation();
    
    const { 
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_NotificationTask = null,
        inputParam_ShowNotificationTask = null,
        inputParam_ParentEditMode = true,
        inputParam_ForceShowComment = false
    } = props;

    const { token: currentAuth } = useSelector((state) => state.auth);
    const aux_userName = currentAuth !== null ? currentAuth.token.userName.split('\\')[1] : null;

    const [objMessage, setObjMessage] = useState({ id: null });
    useGetMessageById(
        inputParam_NotificationTask.classReferencedId,
        0,
        setObjMessage,
        null,
        null
    );

    const [fireSetBook, setFireSetBook] = useState(false);
    const [objBook, setObjBook] = useState({ id: null });
    useGetBookById(!isNullUndefined(objMessage.id) ? objMessage.bookId : null, objBook.id, null, null, setObjBook, null, fireSetBook)

    const [userProps, setUserPropsObject] = useState(__OBJECT_STRUCTURE_GetUserProps());
    useGetMessageBookMemberRelationshipProps(!isNullUndefined(objBook) ? objBook.id : null, aux_userName, userProps, setUserPropsObject);

    const [dataFilled, setDataFilled] = useState(false);
    const [documentList, setDocumentList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 5, filters: []});
    useGetDocumentListByMessageFromMessageBox(inputParam_NotificationTask.classReferencedId, setDocumentList, dataFilled, setDataFilled);

    return (<>
                {
                    inputParam_IsPanelOpen && objMessage.id && objBook.id &&
                    <SidePanelEdit
                        setterObjMessageList={null}
                        bookObject={objBook}
                        messageObject={objMessage}
                        isPanelOpen={inputParam_IsPanelOpen}
                        currentUserName={aux_userName}
                        userProps={userProps}
                        setterDocumentList={null}
                        setterIsPanelOpen={inputParam_SetterIsPanelOpen} 
                        setterObjMessage={setObjMessage}
                        setFireGetMessage={setFireSetBook}
                        notificationMode={true}
                        notificationTask={inputParam_NotificationTask}
                        showNotificationTask={inputParam_ShowNotificationTask}
                        parentEditMode={inputParam_ParentEditMode}
                        forceShowComment={inputParam_ForceShowComment}
                    />
                }
            </>
    );
};

SidePanelViewBookTask.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,  
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,      
};

export default SidePanelViewBookTask;